import { Form, Input, Row, Col, Switch, InputNumber, ColorPicker, Select } from 'antd';
import { useRef, useEffect, useState } from 'react';
import AntDraggableModal from '../../../utils/extend/AntDraggableModal';
import WebEditUniversal, { WEUExtendPropsType } from '../../system/WebEditUniversalNewEx';
import fetchApi from '../../../utils/api/fetchApi';
import getList from '../../../utilsTsx/universal/getList';

const EditComponent = (props: any) => {
    const [form] = Form.useForm();
    const { data } = props;
    const { giftCardPlansId } = data?.sendPageData;
    if (data.type === 'NEW') {
        form.setFieldValue('giftCardPlansId', giftCardPlansId);
    }
    const ref = useRef<any>(undefined);
    const [merchantData, setMerchantData] = useState<any>();
    const [giftCardPlansData, setGiftCardPlansData] = useState<any>();
    const [wxAccountData, setWxAccountData] = useState<any>();

    useEffect(() => {
        let serviceUrl;
        if (ref.current) {
            serviceUrl = ref.current.defaultService;
        }
        fetchApi.GET(serviceUrl,
            {
                apiId: 'generalData',
                apiExtend: 'wxAccountList',
                apiData: {
                    slectType: 'wxPay'
                }
            }).then(res => {
                if (res.success) {
                    setWxAccountData(res.data)
                }
            });
        fetchApi.GET(serviceUrl, {
            apiId: 'merchant',
            apiExtend: 'showList'
        }).then(res => {
            if (res.success === true) {
                setMerchantData(res.data);
            }
        })
        fetchApi.GET(serviceUrl, {
            apiId: 'giftCardPlans',
            apiExtend: 'showList'
        }).then(res => {
            if (res.success === true) {
                setGiftCardPlansData(res.data);
            }
        })
    }, []);

    const handleOk = (e: any) => {
        ref.current.handleOk();
    };
    const handleCancel = (e: any) => {
        ref.current.handleCancel();
    };

    let extendProps: WEUExtendPropsType = {
        ...props,
        form,
        apiId: 'giftCardPlansApplicablesMerchants',
        serviceId: 'business'
    };

    return (
        <><WebEditUniversal ref={ref} props={extendProps} />
            <AntDraggableModal
                title={(data.type === 'NEW' ? '新增' : '编辑') + '礼品卡方案适合商户'}
                open={true}
                okText='确定'
                cancelText='取消'
                onOk={handleOk}
                onCancel={handleCancel}
                closable={false}
                maskClosable={false}
                width={700}
            >
                <Form
                    form={form}
                    name="Edit"
                    onFinish={handleOk}
                    onKeyDown={(e: any) => {
                        if (e.key === 'Enter') {
                            handleOk(e)
                        }
                    }}>

                    <Row gutter={[8, 0]}>
                        <Col span={12}>
                            <Form.Item
                                label="ID"
                                name="id">
                                <Input disabled={true} />
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item
                                label="商户"
                                name="merchantId"
                                rules={[{ required: true, message: '请选择商户!' }]}>
                                <Select
                                    showSearch
                                    placeholder="商户"
                                    optionFilterProp="children"
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {getList.general(merchantData, { itemName: 'merchantName' })}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.Item
                                label="微信支付"
                                name="wxPayId">
                                <Select
                                    showSearch
                                    placeholder="微信支付"
                                    optionFilterProp="children"
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {getList.general(wxAccountData, {
                                        includeNull: true
                                    })}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item
                                label="礼品卡方案"
                                name="giftCardPlansId"
                                rules={[{ required: true, message: '请选择礼品卡方案!' }]}>
                                <Select
                                    disabled={true}
                                    showSearch
                                    placeholder="礼品卡方案"
                                    optionFilterProp="children"
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {getList.general(giftCardPlansData, { itemName: 'planName' })}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={4}>
                            <Form.Item
                                label="状态"
                                name="isUse"
                                valuePropName="checked"
                                initialValue={true}>
                                < Switch checked={true}
                                    checkedChildren="启用"
                                    unCheckedChildren="关闭" />
                            </Form.Item>
                        </Col>

                        <Col span={4}>
                            <Form.Item
                                label="默认支付"
                                name="isDefaultPayment"
                                valuePropName="checked"
                                initialValue={false}>
                                < Switch checked={false}
                                    checkedChildren="是"
                                    unCheckedChildren="否" />
                            </Form.Item>
                        </Col>

                    </Row>
                </Form>
            </AntDraggableModal>
        </>
    )
}

export default EditComponent;